<div class="welcome-user-wrapper flex items-center">
  <i class="fal fa-circle-user"></i>
  <p>Hola, <span class="username">{{username}}</span></p>
</div>